import * as api from "../Api";

export const allApprovedInsurance = () => async (dispatch) => {
  try {
    const { data } = await api.getApprovedInsurance();
    dispatch({ type: "GET_ALL_APPROVED_INSURANCE", payload: data });
  } catch (error) {
    dispatch({ type: "LOAD_FAILED", failed: "GET_ALL_APPROVED_INSURANCE" });
  }
};
